import React from "react";

import { ModalConfirmation } from "@performyard/py-components";

type ConfirmDangerModalProps = {
	isOpen: boolean;
	title: string;
	message: string;
	confirmLabel: string;
	confirmTestId: string;
	/** True while the mutation is in flight, to block a double submit. */
	disabled?: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

/** The destructive-confirmation shape the workflow detail page uses for delete/archive. */
const ConfirmDangerModal = ({
	isOpen,
	title,
	message,
	confirmLabel,
	confirmTestId,
	disabled,
	onConfirm,
	onClose,
}: ConfirmDangerModalProps) => (
	<ModalConfirmation
		isOpen={isOpen}
		onClose={onClose}
		dangerouslySetClassName="w-[432px]"
		title={title}
		message={message}
		negativeButtonProps={{
			children: "Cancel",
			variant: "outline",
			color: "neutral",
			onClick: onClose,
		}}
		positiveButtonProps={{
			children: confirmLabel,
			color: "red",
			disabled,
			onClick: onConfirm,
			"data-testid": confirmTestId,
		}}
	/>
);

export default ConfirmDangerModal;
